'use client';

import { createContext, useContext, useEffect, type ReactNode } from 'react';
import { useTenant } from '@/contexts/TenantContext';
import { useTenantMapConfigStore } from '@/stores/tenant-map-config-store';
import type { UnitSystem } from '@/lib/api/locationConfig';

const UnitSystemContext = createContext<UnitSystem>('imperial');

export function UnitSystemProvider({ children }: { children: ReactNode }) {
  const { selectedTenant } = useTenant();
  const unitSystem = useTenantMapConfigStore((state) => state.unitSystem);
  const fetchConfig = useTenantMapConfigStore((state) => state.fetchLocationConfig);

  // Fetch is idempotent — store deduplicates by tenant and caches results.
  useEffect(() => {
    if (selectedTenant) {
      fetchConfig(selectedTenant);
    }
  }, [selectedTenant, fetchConfig]);

  return (
    <UnitSystemContext.Provider value={unitSystem}>
      {children}
    </UnitSystemContext.Provider>
  );
}

export function useUnitSystem(): UnitSystem {
  return useContext(UnitSystemContext);
}
